import React from 'react';
import tw from 'twin.macro';

export const Title = tw.h2`text-lg`;
